import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import styles from './ChartCard.module.css';

export const ChartCard = ({ chartImgUrl }) => {
  const { t } = useTranslation(i18next.language);

  return (
    <div className={styles.chartCard}>
      <div className={styles.chartTitle}>{t('tripTypesPageTemplate.tripDuration.chartCardTitle')}</div>
      <div className={styles.divider} data-testid="divider" />
      <div className={styles.chartContent}>
        <img
          src={chartImgUrl}
          alt={t('tripTypesPageTemplate.tripDuration.chartImageAlt')}
          className={styles.chartImage}
        />
      </div>
    </div>
  );
};

ChartCard.propTypes = {
  chartImgUrl: PropTypes.string.isRequired
};
